import {Component, OnInit} from '@angular/core';
import {CartService} from "../../services/payment-area/cart.service";
import {Subject, takeUntil} from "rxjs";
import {StoreService} from "../../services/store.service";
import {NavigationEnd, Router} from "@angular/router";
import {AuthService} from "../../services/auth/auth.service";

export const pathSegmentContainsPersonalRoute = '/personal';

@Component({
    selector: 'app-cart-icon-header',
    templateUrl: './cart-icon-header.component.html',
    styleUrls: ['./cart-icon-header.component.scss'],
    standalone: false
})
export class CartIconHeaderComponent implements OnInit {
  isPersonalRoute: boolean
  totalPaymentsInCarts$ = this.cartService.getAllPaymentsInCarts$
  totalPayments$ = this.cartService.totalPayments$;

  private destroyed = new Subject<void>();

  constructor(
    private cartService: CartService,
    public storeService: StoreService,
    private authService: AuthService,
    private router: Router) {
    this.isPersonalRoute = this.isPersonalRouteCalc(this.router.url)
    this.router.events
      .pipe(takeUntil(this.destroyed))
      .subscribe(e => this.isPersonalRoute = e instanceof NavigationEnd ?
        this.isPersonalRouteCalc(e.url) :
        false
      )
  }
  isPersonalRouteCalc = (url: string) => {
    return url.includes(pathSegmentContainsPersonalRoute) || (url.includes('payment-return') && this.authService.isLogged())
  }
  ngOnInit(): void { }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }

  getRoute(isPersonalRoute: boolean) {
    const isLogged = this.authService.isLogged();
    let routeUrl = '/personal/payment-area/cart';
    if(!isLogged && !isPersonalRoute) {
      routeUrl = '/services-without-registration/payment-area/cart';
    }
    return routeUrl;
  }
}
